import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'fr_LU',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'ac71faa5-3a90-4eb0-a6a7-6baae58cdc2a',
  ''
);
